import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IEntitlementPurchaseResponse, ISubscribeEntitlementRequest } from '../../../entity/interface/iEntitlements';
export interface ISubscribeUseCase {
    execute(
        username: string,
        payload: ISubscribeEntitlementRequest,
        token: string
    ): Promise<IEntitlementPurchaseResponse>;
}

export class SubscribeUseCase implements ISubscribeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscribeRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        payload: ISubscribeEntitlementRequest,
        token: string
    ): Promise<IEntitlementPurchaseResponse> {
        return this.subscribeRepository.subscribe(username, payload, token);
    }
}
